import React, { useEffect, useRef, useState, useContext } from "react";
import constant from "../../Components/Services/constant";
import { ApiService } from "../../Components/Services/apiservices";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { BrowserView, MobileView } from "react-device-detect";
import { validEmail } from "../../Components/Elements/Regex";
import Alert from "react-bootstrap/Alert";
import { useLocation } from "react-router-dom";
import DataContext from "../Elements/eventContext";
import ScrollToTop from "react-scroll-to-top";
import Modal from "react-bootstrap/Modal";
import CartModal from "../Modals/cart_modal";
import Spinner from "../../Containers/Spinner/spinner";

function Footer() {
  const location = useLocation();
  const didMountRef = useRef(true);
  const cartModal = () => {
    contextValues.setToggleCartModal(!contextValues.toggleCartModal);
  };
  const [settingImagePath, setSettingImagePath] = useState("");
  const [footer1, setFooter1] = useState("");
  const [footer2, setFooter2] = useState("");
  const [footer3, setFooter3] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [setSession, SetSession] = useState("");
  const [accountStatus, SetAccountStatus] = useState(false);
  const [whatsappUrl, setWhatsappUrl] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const contextValues = useContext(DataContext);
  const [newsletterDetails, setNewsletterDetails] = useState({
    newsletter_email: "",
  });
  useEffect(() => {
    if (didMountRef.current) {
      // getSettingsData();
      getFooterData();
      SetSession(localStorage.getItem("USER_TOKEN"));
      const currentPath = location.pathname;
      const isAccountOverview = currentPath.includes(
        "/account/account-overview"
      );
      const isAddressPage = currentPath.includes("/account/address");
      const isWishlistPage = currentPath.includes("/account/wishlist");
      const ishelpandsupportPage = currentPath.includes(
        "/account/help-and-support"
      );
      const isaboutusPage = currentPath.includes("/account/about-us");

      if (
        isAccountOverview ||
        isWishlistPage ||
        isAddressPage ||
        ishelpandsupportPage ||
        isaboutusPage
      ) {
        SetAccountStatus(true);
      } else {
        SetAccountStatus(false);
      }
      if (!localStorage.getItem("modalShown")) {
        setShowWelcomeModal(true);
        localStorage.setItem("modalShown", "true");
      }
      
    }
    didMountRef.current = false;
  }, []);

  const getFooterData = () => {
    ApiService.fetchData("footer").then((res) => {
      if (res.status == "success") {
        setFooter1(res.footerData.footer_desc1);
        setFooter2(res.footerData.footer_desc2);
        setFooter3(res.footerData.footer_desc3);
      }
    });
  };
  const onTodoChange = (e) => {
    const { name, value } = e.target;
    setNewsletterDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const resetNewsletterForm = () => {
    setNewsletterDetails({ newsletter_email: "" });
  };
  const newsletterProcess = () => {
    let counter = 0;
    const myElements = document.getElementsByClassName("newsletterRequired");
    for (let i = 0; i < myElements.length; i++) {
      if (myElements[i].value == "") {
        myElements[i].style.border = "1px solid red";
        counter++;
      } else {
        myElements[i].style.border = "";
      }
    }
    if (counter == 0) {
      setErrorMessage("");
      if (!validEmail.test(newsletterDetails.newsletter_email)) {
        setErrorMessage("Please enter valid Email Id");
        return false;
      }
      ApiService.postData("newsletter-process", newsletterDetails).then(
        (res) => {
          if (res.status == "success") {
            setSuccessMessage(res.message);
            resetNewsletterForm();
            setTimeout(() => {
              setSuccessMessage("");
            }, 2000);
          } else {
            setErrorMessage(res.message);
            setTimeout(() => {
              setErrorMessage("");
            }, 2000);
          }
        }
      );
    }
  };

  const loginModal = () => {
    contextValues.setToggleLoginModal(!contextValues.toggleLoginModal);
  };
  return (
    <>
      <BrowserView>
        <footer>
          <Container>
            <Row>
              <Col lg={4}>
                <div className="footer-logo mb-3">
                  <a href="/">
                    <img
                      src={
                        contextValues.settingData.footer_logo != null
                          ? contextValues.settingImageBaseUrl +
                            contextValues.settingData.footer_logo
                          : "/img/logofooter.png"
                      }
                      alt={contextValues.settingData.footer_logo}
                      width={200}
                      height={39}
                    />
                  </a>
                </div>
                <div dangerouslySetInnerHTML={{ __html: footer1 }}></div>
                <div className="footer-contact">
                  <ul>
                    {/* <li>
                  <a href="https://goo.gl/maps/kbVCAczvv6s9tjdHA" target="new">
                  <i className="d-icon-map mr-5"></i>
                  <span>{settingData.address}</span>
                  </a>
                  </li> */}
                    <li>
                      <a href={"tel:" + contextValues.settingData.admin_mobile}>
                        <i className="d-icon-phone mr-5"></i>
                        <span>{contextValues.settingData.admin_mobile}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={
                          "tel:" +
                          contextValues.settingData.admin_support_mobile
                        }
                      >
                        <i className="d-icon-phone mr-5"></i>
                        <span>
                          {"+91"}-
                          {contextValues.settingData.admin_support_mobile}
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={"mailto:" + contextValues.settingData.admin_email}
                      >
                        <i className="fa fa-envelope  mr-5"></i>
                        <span>{contextValues.settingData.admin_email}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col lg={2}>
                <div dangerouslySetInnerHTML={{ __html: footer2 }}></div>
              </Col>
              <Col lg={2}>
                <div dangerouslySetInnerHTML={{ __html: footer3 }}></div>
              </Col>
              <Col lg={4}>
                <div className="footer-title">
                  <h5>Subscribe to Our News Letter</h5>
                </div>
                <p>
                  Enter your email address to register to our newsletter
                  subscription
                </p>
                {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                {successMessage && (
                  <Alert variant="success">{successMessage}</Alert>
                )}
                <div className="subscribe-form mb-4">
                  <input
                    className="email newsletterRequired"
                    type="email"
                    placeholder="Enter your email here.."
                    name="newsletter_email"
                    value={newsletterDetails.newsletter_email}
                    onChange={(e) => onTodoChange(e)}
                  />
                  <div className="subscribe-button">
                    <input
                      id="mc-embedded-subscribe"
                      className="button"
                      type="button"
                      name="subscribe"
                      value="Subscribe"
                      onClick={newsletterProcess}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          {/* <Modal
            show={showWelcomeModal}
            onHide={() => setShowWelcomeModal(false)}
            centered
            className="custom-popup"
            contentClassName="custom-popup-modal"
          >
            <button
              type="button"
              className="close-modal-button"
              onClick={() => setShowWelcomeModal(false)}
            >
              &times;
            </button>
            <Modal.Body className="text-center p-0">
              <a href="/collection/all">
                <img
                  className="modal-image"
                  src="/img/popup2.jpg"
                  alt="Welcome"
                />
              </a>
            </Modal.Body>
          </Modal> */}
          <Spinner />
        </footer>
        <div className="footer-bottom">
          <div className="footer-left mb-4">
            <figure className="payment">
              <img src="/img/payment-method_69e7ec.svg" alt="payment" />
            </figure>
          </div>

          <div className="footer-center mb-4">
            <p className="copyright mb-0">
              Ashna Vaswani © {new Date().getFullYear()}. All Rights Reserved
            </p>
          </div>

          <div className="footer-right">
            <div className="footer-social">
              <ul>
                {contextValues.settingData.facebook_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.facebook_url}
                      target="new"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}

                {contextValues.settingData.twitter_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.twitter_url}
                      target="new"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}

                {contextValues.settingData.pinterest_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.pinterest_url}
                      target="new"
                    >
                      <i className="fab fa-pinterest"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}

                {contextValues.settingData.instagram_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.instagram_url}
                      target="new"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="whatsapp">
          <a
            href={
              "https://wa.me/" + contextValues.settingData.admin_whatsapp_no
            }
            target="new"
          >
            <img src="/img/whatsapp1.png"></img>
          </a>
        </div>
        <ScrollToTop smooth style={{ bottom: "75px", right: "23px" }}>
          {" "}
          <i className="fas fa-chevron-up"></i>{" "}
        </ScrollToTop>
      </BrowserView>

      <MobileView>
        <div className="footer-bottom">
          <div className="footer-left mb-4">
            <figure className="payment">
              <img src="img/payment-method_69e7ec.svg" alt="payment" />
            </figure>
          </div>

          <div className="footer-center mb-4">
            <p className="copyright mb-0">
              Ashna Vaswani © 2025. All Rights Reserved
            </p>
          </div>

          <div className="footer-right">
            <div className="footer-social">
              <ul>
                {contextValues.settingData.facebook_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.facebook_url}
                      target="new"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}

                {contextValues.settingData.twitter_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.twitter_url}
                      target="new"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}

                {contextValues.settingData.pinterest_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.pinterest_url}
                      target="new"
                    >
                      <i className="fab fa-pinterest"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}

                {contextValues.settingData.instagram_url != null ? (
                  <li>
                    <a
                      href={contextValues.settingData.instagram_url}
                      target="new"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </div>
          </div>
        </div>

        <div className="appBottomMenu">
          <a
            href="/"
            className={location.pathname == "/" ? "item active" : "item"}
          >
            <div className="col">
              <i className="d-icon-home"></i>
              <span>Home</span>
            </div>
          </a>
          <a
            href="/category"
            className={
              location.pathname.includes("/category") ? "item active" : "item"
            }
          >
            <div className="col">
              <i className="d-icon-layer"></i>
              <span>Categories</span>
            </div>
          </a>
          {setSession ? (
            <a
              href="/account/orders"
              className={
                location.pathname.includes("/account/orders")
                  ? "item active"
                  : "item"
              }
            >
              <div className="col">
                <i className="d-icon-truck"></i>
                <span>Orders</span>
              </div>
            </a>
          ) : (
            <a href="javascript:void(0)" className="item" onClick={loginModal}>
              <div className="col">
                <i className="d-icon-truck"></i>
                <span>Orders</span>
              </div>
            </a>
          )}
          <a
            href="javascript:void(0)"
            className="item"
            onClick={(e) => cartModal()}
          >
            <div className="col">
              <i className="d-icon-bag"></i>
              <span>Cart</span>
              <span className="cart-count">{contextValues.cartCount}</span>
            </div>
          </a>
          {setSession ? (
            <a
              href="/account/account-overview"
              className={accountStatus ? "item active" : "item"}
            >
              <div className="col">
                <i className="d-icon-user"></i>
                <span>Account</span>
              </div>
            </a>
          ) : (
            <a href="javascript:void(0)" className="item" onClick={loginModal}>
              <div className="col">
                <i className="d-icon-user"></i>
                <span>Account</span>
              </div>
            </a>
          )}
        </div>

        <div className="whatsapp-mobile">
          <a
            href={
              "https://wa.me/" + contextValues.settingData.admin_whatsapp_no
            }
            target="new"
          >
            <img src="/img/whatsapp1.png"></img>
          </a>
        </div>
        <ScrollToTop smooth style={{ bottom: "124px", right: "23px" }}>
          {" "}
          <i className="fas fa-chevron-up"></i>{" "}
        </ScrollToTop>
        {/* <Modal
          show={showWelcomeModal}
          onHide={() => setShowWelcomeModal(false)}
          centered
          contentClassName="custom-popup-modal"
        >
          <button
            type="button"
            className="close-modal-button"
            onClick={() => setShowWelcomeModal(false)}
          >
            &times;
          </button>
          <Modal.Body className="text-center p-0">
            <a href="/collection/all">
              <img
                className="modal-image"
                src="/img/popup2.jpg"
                alt="Welcome"
              />
            </a>
          </Modal.Body>
        </Modal> */}
        <Spinner />
      </MobileView>
    </>
  );
}
export default Footer;
